import type {
	CommentRole,
	RecentPromotionsRefundedStatus,
	RecentPromotionsSource,
} from '@change-corgi/middle-end-gql-schema';

const PETITION_ACTIVITY_PROMOTION_SOURCES: readonly RecentPromotionsSource[] = [
	'PROMOTION',
	'FREE_PROMOTION',
	'STARTER_FREE_PROMOTION',
] as const;
const PETITION_ACTIVITY_PROMOTION_REFUNDED_STATUS: RecentPromotionsRefundedStatus = 'NON_REFUNDED';
const PETITION_ACTIVITY_COMMENT_ROLES: readonly CommentRole[] = [
	'COMMENT',
	'SUPPORTER_COMMENT',
	'VIDEO_COMMENT',
] as const;

/** The fixed set of promotion sources to request when querying petition activity promotions. */
export function getPetitionActivityPromotionSources(): readonly RecentPromotionsSource[] {
	return PETITION_ACTIVITY_PROMOTION_SOURCES;
}

/** The refunded status to request when querying petition activity promotions (we only show non-refunded ones). */
export function getPetitionActivityPromotionRefundedStatus(): RecentPromotionsRefundedStatus {
	return PETITION_ACTIVITY_PROMOTION_REFUNDED_STATUS;
}

/** The fixed set of comment roles to request when querying petition activity comments. */
export function getPetitionActivityCommentRoles(): readonly CommentRole[] {
	return PETITION_ACTIVITY_COMMENT_ROLES;
}
